import { getTodayEvents } from "./getToday";
import { filterSportsByCode } from "../functions/functions";
import { fetchJSONWithFallback } from "./getFetchReusable";

export default function fetchDataInParallel({
  fetchData,
  apiEndpoints,
  inicial,
  sportValue,
  onDataLoaded,
  onUpdateData,
  onError,
  assignValuesToTab,
  currentTabRef,
  selectedDateRef,
  version
}) {
  return new Promise(async (resolve, reject) => {
    let updateInterval = null;

    try {
      // Cargar solo HOY
      const todayIndex = inicial - 1;
      const todayEndpoint = apiEndpoints[todayIndex];

      let todayData;
      if (typeof todayEndpoint === 'string') {
        todayData = await fetchData(todayEndpoint);
      } else {
        const result = await fetchJSONWithFallback(todayEndpoint.primary, todayEndpoint.fallback, version);
        todayData = result.data;
      }

      // Procesar datos de HOY
      let processedData = todayData;
      if (sportValue) {
        processedData = filterSportsByCode(processedData, sportValue);
      }

      // Asignar datos de HOY
      assignValuesToTab?.(processedData, inicial);

      // Notificar datos cargados
      onDataLoaded?.(processedData);

      // Función para verificar si la fecha seleccionada es HOY
      const isSelectedDateToday = () => {
        const selectedDateStr = selectedDateRef?.current;
        if (!selectedDateStr) return false;

        const today = new Date();
        const todayDay = String(today.getDate()).padStart(2, '0');
        const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
        const todayYear = String(today.getFullYear());
        const todayStr = `${todayDay}/${todayMonth}/${todayYear}`;
        return selectedDateStr === todayStr;
      };

      // Configurar actualización automática para HOY cada 60 segundos
      updateInterval = setInterval(async () => {
        try {
          // Obtener la fecha de la tab actual
          const currentTabDate = currentTabRef?.current?.date;
          
          if (!currentTabDate) {
            return;
          }

          // Obtener la fecha de hoy en formato DD/MM/YYYY
          const today = new Date();
          const todayDay = String(today.getDate()).padStart(2, '0');
          const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
          const todayYear = String(today.getFullYear());
          const todayStr = `${todayDay}/${todayMonth}/${todayYear}`;

          // Solo refrescar si la fecha de la tab actual es HOY
          if (currentTabDate !== todayStr) {
            return;
          }

          const todayEndpoint = apiEndpoints[inicial - 1];
          let updatedData;

          if (typeof todayEndpoint === 'string') {
            const result = await getTodayEvents();
            updatedData = result.statusCode === 200 ? result.data : await fetchData(todayEndpoint);
          } else {
            const result = await fetchJSONWithFallback(todayEndpoint.primary, todayEndpoint.fallback, version);
            updatedData = result.data;
          }

          let refreshedData = updatedData;
          if (sportValue) {
            refreshedData = filterSportsByCode(refreshedData, sportValue);
          }

          // Actualizar la UI con los datos nuevos
          // Usar el índice de la tab actual (currentTab - 1)
          const currentTabIndex = currentTabRef?.current?.current - 1;
          onUpdateData?.(refreshedData, currentTabIndex);
        } catch (error) {
          console.error("Error al obtener los datos de api - Today:", error);
          onError?.(error);
        }
      }, 60000);

      resolve(() => {
        if (updateInterval) {
          clearInterval(updateInterval);
        }
      });

    } catch (error) {
      console.error("Error al obtener los datos de las APIs.", error);
      if (updateInterval) {
        clearInterval(updateInterval);
      }
      onError?.(error);
      reject(error);
    }
  });
}
